/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgFileM4A = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="M20 7.586V10h-2V9h-5V4H6v16h12v-1h2v3H4V2h10.414zM15 7h1.586L15 5.414z" />
        <path d="m10.75 15.288 1.571-3.305h1.125V17h-1.062v-3.249l-1.325 2.766h-.662l-1.325-2.721V17H8.03v-5.017h1.124zm6.586-.123h.69v.896h-.69V17h-1.02v-.939h-2.312v-.828l2.373-3.18h.959zm-2.219 0h1.226V13.48zM22.984 17h-1.2l-.332-1.028h-1.85L19.272 17H18.12l1.904-5.017h1.042zm-3.092-1.938h1.266l-.637-1.972z" />
      </g>
    </g>
  </Icon>
);
export { SvgFileM4A as FileM4A };
